import * as Yup from 'yup';
import mapValues from 'lodash/mapValues';

export const createStrategytSchema = Yup.object().shape({
  name: Yup.string().required('Preencha o nome da estratégia'),
  executionPeriodicityInDays: Yup.number()
    .required('Preencha a Periodicidade de execução da régua')
    .min(0, 'Valor deve ser maior ou igual à zero'),
  selectedServiceCategories: Yup.lazy((obj) =>
    Yup.object(
      mapValues(obj, () =>
        Yup.lazy((mailingList) =>
          Yup.object(
            mapValues(mailingList, () =>
              Yup.object().shape({
                activation: Yup.boolean().optional(),
                priority: Yup.number().when('activation', {
                  is: true,
                  then: Yup.number().required('Insira um valor'),
                }),
              }),
            ),
          )
            .required(
              'As mailings devem estar priorizadas de maneira sequencial e sem repetições.',
            )
            .test(
              'adjustPriorities',
              'As mailings devem estar priorizadas de maneira sequencial e sem repetições.',
              (mailingRules) => {
                const mailingRuleKeys = Object.keys(mailingRules);
                const usedPriorities = {} as { [keys: string]: boolean };

                const hasSamePriority = mailingRuleKeys.some((mrKey) => {
                  const currentPriority = mailingRules[mrKey].priority;
                  if (!currentPriority) {
                    return false;
                  }

                  if (usedPriorities[currentPriority]) {
                    return true;
                  }

                  usedPriorities[currentPriority] = true;
                  return false;
                });

                if (hasSamePriority) {
                  return false;
                }

                const isNotOrdered = Object.keys(usedPriorities).some(
                  (priority, index) => Number.parseInt(priority) !== index + 1,
                );

                return !isNotOrdered;
              },
            ),
        ),
      ),
    )
      .required(
        'No mínimo uma ação precisa ter uma Régua de Mailing priorizada.',
      )
      .test(
        'notEmpty',
        'Priorize uma Régua de Mailing',
        (value, testContext) => {
          let firstKeyError = '';
          const strategiesServicesKeys = Object.keys(value);
          const isValid = strategiesServicesKeys.some((strKey) => {
            const mailingRules = value[strKey];
            const mailingRuleKeys = Object.keys(mailingRules);
            const isValidStrategy = mailingRuleKeys.some(
              (mrKey) =>
                mailingRules[mrKey].activation && mailingRules[mrKey].priority,
            );

            if (!isValidStrategy && !firstKeyError.length) {
              firstKeyError = strKey;
            }
            return isValidStrategy;
          });

          if (!isValid) {
            throw testContext.createError({
              path: `selectedServiceCategories.grid`,
            });
          }

          return isValid;
        },
      ),
  ),
});
